import IdLessRestService from "./IdLessRestService";

export default class StarfishGiftCardsService extends IdLessRestService {
    constructor() {
        super('/api/v1/starfishgiftcards');
    }

    config(country) {
        return this.get(`${this.baseUrl}/config${country ? `?country=${country}` : ''}`);
    }

    /**
     * The response carries the plaintext code, which the API will never return
     * again. It must be shown to the buyer immediately and never persisted.
     */
    purchase(country, amount) {
        return this.post(`${this.baseUrl}/purchase`, { country, amount });
    }

    purchased(status = 'all') {
        return this.get(`${this.baseUrl}/purchased/${status}`);
    }

    /** Checksum check only. Does not consume a redemption attempt. */
    validate(code) {
        return this.post(`${this.baseUrl}/validate`, { code });
    }

    redeem(code) {
        return this.post(`${this.baseUrl}/redeem`, { code });
    }
}
